import { Component, OnInit } from '@angular/core';
import { InterviewStatusService } from './interview-status.service';
import { VendorService } from '@services/vendor.service';
import { Priority, HeaderText } from '@constants/global.enum';
import {Router} from '@angular/router';

@Component({
  selector: 'app-interview-status',
  templateUrl: './interview-status.component.html',
  styleUrls: ['./interview-status.component.scss'],
})
export class InterviewStatusComponent implements OnInit {
  navigateToCandidates(): void {
    this.router.navigate(['/vendor/open-positions'], {
      queryParams: { tab: 'candidates' },
    });
  }

  totalPositions: number = 0;
  totalProfiles: number = 0;
  onboardPending: number = 0;
  selectedMonth: number = 1;
  selectedYear: number = new Date().getFullYear();
  vendorId: number | null = null;
  month: { label: string; value: number; year: number; selected?: boolean }[] = [];
  priority = Priority;
  headerText = HeaderText;

  get funnelMax(): number {
    return Math.max(this.totalPositions, this.totalProfiles, this.onboardPending, 1);
  }

  constructor(
    private interviewStatusService: InterviewStatusService,
    private vendorService: VendorService,
    private router: Router
  ) {}

  ngOnInit() {
    this.generateLast12Months();
    const now = new Date();
    const currentMonthLabel = now.toLocaleString('default', { month: 'long', year: 'numeric' });
    const currentMonthOption = this.month.find((option) => option.label === currentMonthLabel);
    if (currentMonthOption) {
      this.selectedMonth = currentMonthOption.value;
      this.selectedYear = currentMonthOption.year;
    }
    this.vendorService.getCurrentVendor().subscribe((vendor) => {
      if (vendor && vendor.id) {
        this.vendorId = Number(vendor.id);
        this.fetchInterviewStatusData(this.vendorId, this.selectedMonth, this.selectedYear);
      }
    });
  }

  generateLast12Months() {
    const now = new Date();
    for (let i = 0; i < 12; i++) {
      const monthDate = new Date(now.getFullYear(), now.getMonth() - i);
      const monthLabel = monthDate.toLocaleString('default', { month: 'long', year: 'numeric' });
      const monthValue = monthDate.getMonth() + 1;
      const yearValue = monthDate.getFullYear();
      this.month.push({ label: monthLabel, value: monthValue, year: yearValue, selected: i == 0 });
    }
  }

fetchInterviewStatusData(vendorId: number, month: number, year?: number) {
  const selectedYear = year ?? new Date().getFullYear();
  this.interviewStatusService.getVendorInterviewStatus(vendorId, month, selectedYear).subscribe({
    next: (data: any) => {
      if (data && typeof data === 'object' && 'data' in data) {
        const interviewStatus = data['data'];
        if (interviewStatus && typeof interviewStatus === 'object') {
          this.totalPositions = interviewStatus['openPositions'] || 0;
          this.totalProfiles = interviewStatus['profilesSubmitted'] || 0;
          this.onboardPending = interviewStatus['onboardingPending'] || 0;
        } 
      } else {
        this.showError('Unexpected API response structure.');
        this.resetInterviewStatusData();
      }
    },
  });
}

  // Helper method to reset interview status data
  private resetInterviewStatusData() {
    this.totalPositions = 0;
    this.totalProfiles = 0;
    this.onboardPending = 0;
  }

  onMonthChange(event: any) {
    let selectedOption: { label: string; value: number; year: number; selected?: boolean } | undefined;
    if (typeof event === 'string') {
      selectedOption = this.month.find((option) => option.label === event);
    } else if (event.value) {
      selectedOption = this.month.find((option) => option.value === Number(event.value));
    }
    if (!selectedOption) {
      this.showError('Invalid month selected.');
      return;
    }
    this.selectedMonth = selectedOption.value;
    this.selectedYear = selectedOption.year;
    if (this.vendorId) {
      this.fetchInterviewStatusData(this.vendorId, this.selectedMonth, this.selectedYear);
    }
  }

  // Helper method to show error messages using alert
  private showError(message: string) {
    alert(message);
  }

  goToVendor():void{
    this.router.navigate(['/vendor']);
  }
}